import { Table } from '@tanstack/react-table'
import { MultiSelectCombobox, SelectOption } from '@/components/form-components/MultiSelectCombobox'
import { SkillSummary } from './platformAgentSkillsTableUtils'

const scopeOptions: SelectOption<string>[] = [
  { value: 'platform', label: 'Platform' },
  { value: 'owned', label: 'Owned by me' },
  { value: 'shared', label: 'Shared with me' },
  { value: 'public', label: 'Public' },
]

type PlatformAgentSkillsFiltersProps = {
  table: Table<SkillSummary>
}

export function PlatformAgentSkillsFilters({ table }: PlatformAgentSkillsFiltersProps) {
  const selectedScopes = ((table.getColumn('scope')?.getFilterValue() as string[] | undefined) ?? []).filter(Boolean)

  return (
    <div className="w-56">
      <MultiSelectCombobox
        triggerClassName="h-9"
        renderBadgesInTrigger
        options={scopeOptions}
        selectedValues={selectedScopes}
        onSelectionChange={(values) => table.getColumn('scope')?.setFilterValue(values.length > 0 ? values : undefined)}
        placeholder="By scope"
        searchPlaceholder="Search scopes..."
        emptyMessage="No scopes found."
      />
    </div>
  )
}
